import './CheaderHalf.scss';
import { AiOutlineSearch, AiOutlineShoppingCart } from "react-icons/ai";
import logo from '../assets/clogo.png';
import { Link, useHistory } from 'react-router-dom'
import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineHeart,HiMenu } from "react-icons/hi";
import { BiBell } from "react-icons/bi";
import { FiChevronDown } from "react-icons/fi";
import Overlay from 'react-bootstrap/Overlay'
import Popover from 'react-bootstrap/Popover'
import axios from "axios";
import { globleAPI as Global } from '../globals'
import girl from '../assets/emojiwindle.png';

function CheaderHalf(props: any) {
  const [localdata] = useState(localStorage.getItem('userid') || '')
  const [SugestionBox, setSugestionBox] = useState(false);
  const [SearchedValue, setSearchedValue] = useState('');
  const [SuggestionData, setSuggestionData] = useState<any>([]);
  const [token] = useState(localStorage.getItem('token') || '')
  const [first_name] = useState(localStorage.getItem('first_name') || '')
  const [last_name] = useState(localStorage.getItem('last_name') || '')
  const [imageProfile] = useState(localStorage.getItem('imageProfile') || '')
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const [cart, setcart] = useState('')
  const history = useHistory();

  useEffect(() => {
    getCartCount()
  }, [])

  const getCartCount = () => {
    axios
      .get("https://lesfemmestesting.dominioninc.org/public/api/GetCartCount?token=" + token)
      .then(response => {
        setcart(response.data.cart_count)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  if (props.cartcheck === true) {
    getCartCount()
  }

  const handleClick = (event: any) => {
    setShow(!show);
    setTarget(event.target);
  };

  const move = (data: any) => {
    if (data === 'home') {
      history.push('/',[data])
    } else if (data === 'cart') {
      history.push('/cart')
    }
  };

  const logOut = () => {
    localStorage.removeItem('userid');
    localStorage.removeItem('token');
    window.location.reload();
  };

  const goDown = () => {
    props.movetoGetApp('get the app')
  };
  
  const searchedDataState = () => {
    if (SearchedValue == '') {
      alert('please add keyword')
    } else {
      history.push('/all-products', ['searchData',SearchedValue]);
    }
  };

  const searchedData = (data: any) => {
    history.push('/all-products', ['searchData',data]);

  };

  const suggestion = (searchedKeyword: any) => {
    if (searchedKeyword == '') {
      setSuggestionData(searchedKeyword)
      setSugestionBox(false)
    } else {
      setSearchedValue(searchedKeyword)
      window.scrollTo(0, 0)
      axios
        .get(Global.GET_ALL_CLASSIFIED_ADS + token + "&search_keyword=" + searchedKeyword + "&is_luxury=0",)
        .then(response => {
          let Allsuggestion = response.data.AllProducts.filter((data: any, id: any) => id < 5)
          setSuggestionData(Allsuggestion)
          setSugestionBox(true)
        })
        .catch(function (error) {
          console.log('response of the api ', error)
        });
    }
  };

  return (
    <div className=' border-bottom  border-danger ' >
      <nav className="navbar navbar-expand  " style={{ height: '7vh' }} >
        <div className="container-fluid ">
          <div className='mobiledisplay  ' style={{width: '100%' }}>
              <div  className='mobiledisplay justify-content-between f-30 main-font primary-color   d-flex flex-row ' style={{width:'100%'}}>
                <div className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                  <HiMenu size="2.1rem" />
                </div>
            
              <div  >
                <img className="touchAble" onClick={() => move('home')} alt='img' height="50rem" src={logo} ></img>
              </div>
              <div onClick={() => move('cart')} className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                  <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', backgroundColor: 'rgb(197, 77, 97)' }} className=' cp-l-6 f-12 cp-r-6 ' >{cart}</p>
                  <AiOutlineShoppingCart size="2.1rem" />
                </div>
            </div>
            <div></div>
          </div>
          <div className='webdisplay primary-color ' style={{ marginLeft: '2%' }}>
            <AiOutlineSearch size='1.8rem' onClick={() => searchedDataState()} />
            <input className='c-searchfield pText ' onChange={(text: any) => suggestion(text.target.value)} placeholder='Search by brand, item...' style={{ padding: 15 }}></input>
          </div>
          {SugestionBox == true ? (
            <div className=" d-flex flex-column position-absolute  cp-l-50 cp-r-50 cp-b-10 cm-l-25  " style={{ marginTop: '16.3%', zIndex: 1, backgroundColor: 'white', width: '50%' }} >
              {SuggestionData.map((data: any) =>
                <label onClick={() => searchedData(data.name)} >{data.name}</label>
              )}
            </div>
          ) : null}
          <div className="collapse navbar-collapse" style={{ justifyContent: 'space-between' }} id="navbarColor02">
          <form>
            </form>
            <div className='webdisplay  main-font primary-color  ' style={{ marginLeft: '12%' }}>
              <img className="touchAble" onClick={() => move('home')} width="150rem" alt='img' src={logo} ></img>
            </div>
            <div style={{ display: 'flex' }} className=' webdisplay'>
              <div className='pointer  cm-r-1rem  bg-color-secondary page-color  main-font f-200 border-radius cp-t-5 cp-b-5 cp-l-10 cp-r-10 d-flex  align-self-center'>
                <label onClick={() => goDown()} className="f-12 label touchAble" >
                  GET THE APP
                </label>
              </div>
              <div className='pointer  cm-r-1rem  bg-color-secondary page-color  main-font f-200 border-radius cp-t-5 cp-b-5 cp-l-10 cp-r-10 d-flex  align-self-center'>
                <label className="f-12 label" >   SELL</label>
              </div>
              <div >
                {localdata !== '' ? (
                  <div className='d-flex'>
                    {imageProfile !== 'null' ? (
                      <img alt="img" className="border" style={{ height: 40, width: 40, borderRadius: 100, marginRight: 2 }} src={Global.IMAGE_PATH + imageProfile}></img>
                    ) : (
                      <img alt="img" className="border" style={{ height: 40, width: 40, borderRadius: 100, marginRight: 2 }} src={girl}></img>
                    )}
                 <div className="cp-r-10 d-flex align-self-center" >
                    <FiChevronDown onClick={handleClick} className='touchAble' size='1.6rem' />
                    </div>
                    <Overlay
                      show={show}
                      target={target}
                      placement="bottom"
                      container={ref.current}
                      containerPadding={50}
                    >
                      <Popover style={{ width: '50%', marginTop: '1.5%' }} id="popover-contained">
                        <Popover.Content >
                          <div className='d-flex flex-row border-bottom cp-b-10 ' >
                            <div className='cp-l-10 cp-t-10' >
                              <label className=" secHeading label  main-font" >{first_name} {last_name}</label><br></br>
                              <label className="primary-color pText font-weight-bold  label main-font" >View Your Profile</label>
                            </div>
                          </div>
                          <div className='border-bottom cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/MyAccount" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Account</Link> </label>
                            <label className=" pText  " >My Sales</label>
                            <label className=" pText " >  <Link to="/purchases" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Purchases</Link> </label>
                          </div>
                          <div className='cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/setting" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >Settings</Link> </label>
                            <label className=" pText " >  <Link to="/faqs" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >Help Center</Link> </label>
                            <label onClick={() => logOut()} className='pText label touchAble hoverUnderLine' >Log Out </label>
                          </div>
                        </Popover.Content>
                      </Popover>
                    </Overlay>
                  </div>
                ) : (
                  <div className="d-flex flex-row" >
                    <div className='cp-t-9  cp-l-10 cp-r-10 h6 main-font label'>
                      <Link to="/signup" className="link" style={{ color: 'rgb(27, 27, 27)' }} >Sign up </Link>
                    </div>
                    <div className='cp-t-9  cp-l-5 cp-r-18 h6 main-font label'>
                      <Link to="/login" className="link" style={{ color: 'rgb(27, 27, 27)', border: 0 }} > Login</Link>
                    </div>
                  </div>
                )}
              </div>
              <div className="pointer cm-r-1rem  cp-t-6 material-icons primary-color">
                <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', backgroundColor: 'rgb(197, 77, 97)', fontSize: 11 }} className=' cp-l-4  cp-r-4 '  ></p>
                <BiBell size="1.5rem" />
              </div>
              <div className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                <HiOutlineHeart size="1.7rem" />
              </div>
              <div onClick={() => move('cart')} className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', backgroundColor: 'rgb(197, 77, 97)', fontSize: 11 }} className=' cp-l-4 f-13 cp-r-4 ' >{cart}</p>
                <AiOutlineShoppingCart size="1.6rem" />
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className=' Sansation-Regular  cp-3 page-color text-center bg-color-primary w100p ' >
        <label className='label f-13  ' style={{ fontStretch: 'ultra-expanded', letterSpacing: 4 }} > FREE       SHIPPING  for  orders  50  AED  and  above  in  UAE</label>
      </div>
    </div>
  );
}

export default CheaderHalf;
